export function toPascalCase(array: string[]): string[] {
  return array.map((str) =>
    str
      .split("")
      .map((char, index) => (index === 0 ? char.toUpperCase() : char))
      .join(""),
  );
}

export function sortYears(arr: string[], order: "asc" | "desc" = "asc"): string[] {
  return arr.sort((a, b) => {
    // Convert strings to numbers and compare
    const yearA = parseInt(a, 10);
    const yearB = parseInt(b, 10);

    if (order === "asc") {
      return yearA - yearB; // Sort in ascending order
    } else {
      return yearB - yearA; // Sort in descending order
    }
  });
}

export function generateYearArray(type?: string) {
  const startYear = 2024;
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(!type ? year : `${year}`);
  }

  return years;
}

export function optionsSelectYears() {
  const years = generateYearArray("string");
  return years.map((item) => ({
    label: item,
    value: item,
  }));
}

export function convertGetParamsArrayToString(params: Object) {
  if (!params || typeof params !== "object" || Object.keys.length === 0) return params;

  const tmpParams: any = { ...params };
  for (const key in tmpParams) {
    if (Array.isArray(tmpParams[key])) {
      tmpParams[key] = JSON.stringify(tmpParams[key]);
    }
  }
  return tmpParams;
}
